import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-WH62GF14CR';

// Initialize Google Analytics — gtag.js is already loaded from index.html
// This only handles SPA page_view tracking on route changes
export const initGA = () => {
  // gtag script is in index.html, no need to inject dynamically
  // Just ensure gtag function exists for event tracking
  if (typeof window !== 'undefined' && !window.gtag) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); };
  }
};

// Track page views — manual SPA page_view event
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: url,
      page_location: window.location.href,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// Specific conversion tracking functions
export const trackContactFormSubmit = (formData) => {
  // REMOVED: was firing duplicate 'contact_form_submit' alongside canonical 'generate_lead' from analytics.js
  // generate_lead is the canonical event for all form submissions
};

export const trackDevisSubmit = (calculationData) => {
  trackEvent('devis_submit', {
    event_category: 'Conversion',
    event_label: 'Calculator Devis',
    surface: calculationData.surface || 0,
    type_beton: calculationData.type_beton || 'Non spécifié',
    total: calculationData.total_estime || 0,
    value: parseFloat(calculationData.total_estime) || 0
  });
};

export const trackRDVSubmit = (appointmentData) => {
  trackEvent('rdv_submit', {
    event_category: 'Conversion',
    event_label: 'Rendez-vous',
    service: appointmentData.service || 'Non spécifié',
    value: 1
  });
};

export const trackPhoneClick = () => {
  // REMOVED: was firing duplicate 'phone_click' alongside canonical 'click_telephone' from analytics.js
  // click_telephone is handled by initLinkTracking() in utils/analytics.js
};

export const trackEmailClick = () => {
  trackEvent('email_click', {
    event_category: 'Contact',
    event_label: 'Email Click',
    value: 1
  });
};

export const trackCTAClick = (ctaName) => {
  trackEvent('cta_click', {
    event_category: 'Engagement',
    event_label: ctaName,
    value: 1
  });
};

// Component to track page views on route change
export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}
